'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggedInBadge = undefined;

var _themeProvider = require('@spp/theme-provider');

var _LoggedInBadge = require('./LoggedInBadge');

var _LoggedInBadge2 = _interopRequireDefault(_LoggedInBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.LoggedInBadge = _LoggedInBadge2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-logged-in-badge')(_LoggedInBadge2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/LoggedInBadge/index.js
 ** module id = 291
 ** module chunks = 1
 **/